module.exports = __webpack_public_path__ + "media/images/person/review_colin-279dce20b523f1945bcd65da40a51f25.jpg";